import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-developer/crm/leads";
const apiDropDownEndpoint= API_BASE_URL_ENV() + "/sales-developer/crm/dropdown/Lead"
const cilApiEndpoint = API_BASE_URL_ENV() + "/sales-developer/crm/send-message";  
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
    sendCil=(data)=>{
        return http.post(cilApiEndpoint, data);
    }

    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
    }

}
